import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "limit"
};
const _hoisted_2 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_Loading = _resolveComponent("Loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "消费限制"
  }), !_ctx.list ? (_openBlock(), _createBlock(_component_van_empty, {
    key: 0,
    description: "暂无数据"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, item => {
    return _openBlock(), _createBlock(_component_van_cell_group, {
      key: item.consumeType,
      inset: "",
      border: false,
      title: item.consumeTypeName
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: item.dayLimitAmount,
        "onUpdate:modelValue": $event => item.dayLimitAmount = $event,
        label: "每日消费限额",
        placeholder: "未设置",
        "input-align": "right",
        type: "number"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_van_field, {
        modelValue: item.monthLimitAmount,
        "onUpdate:modelValue": $event => item.monthLimitAmount = $event,
        label: "每月消费限额",
        placeholder: "未设置",
        "input-align": "right",
        type: "number"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 2
    }, 1032, ["title"]);
  }), 128)), _createElementVNode("footer", null, [_createVNode(_component_van_button, {
    round: "",
    block: "",
    loading: _ctx.loading,
    "loading-text": "保存中...",
    disabled: _ctx.loading,
    color: "linear-gradient(24deg, #5282F0, #608DF4)",
    size: "normal",
    onClick: _ctx.submit
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("保存 ")])),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])])])), _createVNode(_component_Loading, {
    show: _ctx.overlayShow,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => _ctx.overlayShow = $event)
  }, null, 8, ["show"])]);
}